<template>
  <v-btn color="#921639" prepend-icon="fa-solid fa-pen-to-square" text="参加申込をする" rounded="pill" size="x-large" height="4rem" block @click="goTo(
    targetQuerySelector, {
      duration: 300,
      easing: 'easeInOutCubic',
      offset: targetElementTopOffset,
    }
  );" />
</template>
<script setup lang="ts">
interface Props {
  targetQuerySelector: string;
  targetElementTopOffset: number;
};
const props = defineProps<Props>();

import { useGoTo } from 'vuetify';
const goTo = useGoTo();

import { ref, onMounted, onBeforeUnmount } from 'vue';
const hideNav = ref(false);
let observer: IntersectionObserver;

onMounted(() => {
  const target = document.querySelector(props.targetQuerySelector);

  if (!target) return;
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        hideNav.value = entry.isIntersecting
      })
    },
    {
      root: null, // viewport
      threshold: 0.1, // 少しでも見えたらtrue
    }
  );
  observer.observe(target);
});

onBeforeUnmount(() => {
  if (!observer) return;
  observer.disconnect();
});
</script>
